<template>
  <a-modal
    title="设置部门"
    :width="640"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <div class="modal-content">
      <!-- 项目名称 -->
      <div class="modal-title"><span>项目名称：</span>{{ project.name }}</div>
      <!-- 部门提示 -->
      <div class="modal-hint">以下部门同事可在本项目下发布任务：</div>
      <!-- 部门列表 -->
      <a-checkbox-group style="width: 100%;" v-model="checkeds" v-if="deps.length">
        <a-row>
          <a-col class="modal-col" :span="8" v-for="item in deps" :key="item.id">
            <a-checkbox :disabled="confirmLoading" :value="item.id">{{ item.name }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <!-- 没有部门列表 -->
      <div class="modal-empty" v-else>
        <a-empty :image="simpleImage" :description="false" />
        <div>暂无部门，<a @click="touchAddDeps">添加部门</a></div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Pub from '@/utils/public'
import { Empty } from 'ant-design-vue'
import { getDeptList, setDepartment } from '@/api/request'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      // 显示/加载
      visible: false,
      confirmLoading: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      // 项目信息
      project: {},
      // 选中的部门列表
      checkeds: [],
      // 部门列表
      deps: []
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    // 显示
    showModal (data) {
      this.project = data
      // 重置
      this.checkeds = data.deps || []
      this.deps = []
      // 显示
      this.visible = true
      // 获取部门列表
      this.getDeptList()
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        this.visible = false
      }
    },
    // 添加部门
    touchAddDeps () {
      if (this.user.is_admin) {
        Pub.JUMP_ROUTER('/department')
      } else {
        this.$message.error('没有操作权限')
      }
    },
    // 提交
    onSubmit () {
      // 选中列表
      this.confirmLoading = true
      const params = {
        project_id: this.project.id,
        department_ids: this.checkeds
      }
      setDepartment(params).then(res => {
        this.confirmLoading = false
        const { code, data, message } = res
        if (code === 0) {
          this.$message.success('设置成功')
          this.handleCancel()
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.confirmLoading = false
        this.$message.error('设置失败')
      })
    },
    // 获取部门列表
    getDeptList () {
      const params = {
        page: 1,
        page_size: 10000
      }
      getDeptList(params).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.deps = data.data
        }
      })
    }
  }
}
</script>

<style>
.modal-empty .ant-empty {
  margin: 0;
}
</style>
<style lang="less" scoped>
.modal-content {
  // max-height: 400px;
  // overflow-y: auto;
}
.modal-title span {
  color: rgba(0, 0, 0, 0.85);
}
.modal-hint {
  margin-top: 12px;
  margin-bottom: 4px;
}
.modal-col {
  margin-top: 14px;
}
.modal-empty {
  width: 100%;
  text-align: center;
  padding: 24px 0;
}
</style>